import React from 'react';
import { Input, Icon } from 'antd';
import { hashHistory } from 'react-router';

import Events from '../../../services/events.js';

import './FilterPanel.less';

const { Search } = Input;

const filterPanel = (props) => {
  const { activeMobileSearch, mobileSearchValue, title, mobileSearchValueHandler, resetMobileSearchHandler, controlMobileSearch, deviceType } = props;

  const filterText = mobileSearchValue || Events.getFilters().text;

  const handleKeyPress = (event) => {
    const { reverseRedirection, type } = props;
    const typeSearch = type || 'user';

    if(event.key == 'Enter'){
      !reverseRedirection ?
        hashHistory.push(`/Search?type=${typeSearch}&value=${event.target.value}`)
        : hashHistory.push(`/Search?type=${typeSearch}&value=${event.target.value}&redirect=${reverseRedirection}`);
    }
  };

  const mobileSearchCancel = () => {
    resetMobileSearchHandler();
    controlMobileSearch();
  };

  if (deviceType) {
    return (
      <div className="filter-panel">
        <Search
          placeholder={title ? title : 'User search'}
          defaultValue={filterText}
          className="filter-panel-input"
          onKeyPress={handleKeyPress}
          onChange={mobileSearchValueHandler}
        />
      </div>
    )
  }

  return (
    <div className="filter-panel">
      <Input
        placeholder={title ? title : 'User search'}
        defaultValue={filterText}
        className="filter-panel-input"
        onKeyPress={handleKeyPress}
        onChange={mobileSearchValueHandler}
        prefix={activeMobileSearch ? <Icon type="search" /> : null}
        suffix={activeMobileSearch ? (
          <Icon
            type="close"
            onClick={mobileSearchCancel}
            style={{fontSize: '20px'}}
          />
        ) : null}
      />
    </div>
  )
};

export default filterPanel;



// WEBPACK FOOTER //
// ./src/components/Modules/FilterPanel/index.js